import { Layout as AntdLayout } from 'antd'
import type { LayoutProps as AntdLayoutProps } from 'antd'

type HeaderProps = AntdLayoutProps

export function Header(props: HeaderProps) {
  return <AntdLayout.Header {...props} />
}
